'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, useRef, useState } from 'react';
import { useVimeoViewportPlayback } from '@/hooks/useVimeoViewportPlayback';
import { useCasesSliderPinScroll } from '../hooks/useCasesSliderPinScroll';
import css from '../style.module.scss';
import { CasesScrollItemDto, CasesSliderResolvedLayout } from '../types';
import { getSectionHeightVh } from '../utils/getSectionHeightVh';
import CasesSliderMedia from './CasesSliderMedia';
import CasesSliderRightPanel from './CasesSliderRightPanel';
import CasesSliderTabs from './CasesSliderTabs';
interface Props {
  cases: CasesScrollItemDto[];
  layout: CasesSliderResolvedLayout;
  className?: string;
  withContainer?: boolean;
  pinStart?: string;
}
const CasesSliderDesktop: FC<Props> = t0 => {
  const $ = _c(35);
  const {
    cases,
    layout,
    className,
    withContainer: t1,
    pinStart
  } = t0;
  const withContainer = t1 === undefined ? true : t1;
  const sectionRef = useRef(null);
  const pinRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const mediaItemsRef = useRef(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const tabItemsRef = useRef(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const rightItemsRef = useRef(t4);
  const [activeIndex, setActiveIndex] = useState(0);
  const vimeoPlaying = useVimeoViewportPlayback(sectionRef);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mediaItems: mediaItemsRef,
      rightItems: rightItemsRef,
      tabItems: tabItemsRef
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== cases.length || $[5] !== pinStart) {
    t6 = {
      sectionRef,
      pinRef,
      slideRefs: t5,
      slidesCount: cases.length,
      enabled: true,
      onActiveIndexChange: setActiveIndex,
      pinStart
    };
    $[4] = cases.length;
    $[5] = pinStart;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  useCasesSliderPinScroll(t6);
  let t7;
  if ($[7] !== cases.length) {
    t7 = getSectionHeightVh(cases.length);
    $[7] = cases.length;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `${t7}vh`;
  let t9;
  if ($[9] !== t8) {
    t9 = {
      height: t8
    };
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = withContainer && "container";
  const t11 = layout.leftSideText && css.sectionWithLeftSideText;
  let t12;
  if ($[11] !== className || $[12] !== t10 || $[13] !== t11) {
    t12 = clsx(css.section, t10, className, t11);
    $[11] = className;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== activeIndex || $[16] !== cases || $[17] !== layout) {
    t13 = <CasesSliderTabs cases={cases} activeIndex={activeIndex} tabItemsRef={tabItemsRef} layout={layout} />;
    $[15] = activeIndex;
    $[16] = cases;
    $[17] = layout;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== activeIndex || $[20] !== cases || $[21] !== vimeoPlaying) {
    t14 = <CasesSliderMedia cases={cases} activeIndex={activeIndex} mediaItemsRef={mediaItemsRef} vimeoPlaying={vimeoPlaying} />;
    $[19] = activeIndex;
    $[20] = cases;
    $[21] = vimeoPlaying;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== activeIndex || $[24] !== cases || $[25] !== layout) {
    t15 = <CasesSliderRightPanel cases={cases} activeIndex={activeIndex} rightItemsRef={rightItemsRef} layout={layout} />;
    $[23] = activeIndex;
    $[24] = cases;
    $[25] = layout;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t14 || $[29] !== t15) {
    t16 = <div ref={pinRef} className={css.pin}>{t13}{t14}{t15}</div>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t12 || $[32] !== t16 || $[33] !== t9) {
    t17 = <section ref={sectionRef} style={t9} className={t12}>{t16}</section>;
    $[31] = t12;
    $[32] = t16;
    $[33] = t9;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};
export default CasesSliderDesktop;